import { useState, useCallback, useRef } from 'react';

import { Tooltip, Tag, TagStyle, BottomSheet } from '@hh.ru/magritte-ui';
import getConversionType from 'bloko/common/getConversionType';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { TagAwaitingReplyData } from 'src/models/candidatesList';

import styles from './index.less';

const MILLISECONDS_IN_HOUR = 3600000;
const HOURS_IN_DAY = 24;

const TrlKeys = {
    day: {
        one: 'employer.vacancyResponses.tag.awaitingReply.day.one',
        some: 'employer.vacancyResponses.tag.awaitingReply.day.some',
        many: 'employer.vacancyResponses.tag.awaitingReply.day.many',
    },
    hour: {
        one: 'employer.vacancyResponses.tag.awaitingReply.hour.one',
        some: 'employer.vacancyResponses.tag.awaitingReply.hour.some',
        many: 'employer.vacancyResponses.tag.awaitingReply.hour.many',
    },
    awaitingReply: 'employer.vacancyResponses.tag.awaitingReply',
    dropInfo: 'employer.vacancyResponses.tag.awaitingReply.dropInfo',
};

const AwaitingReply: TranslatedComponent<{ data?: TagAwaitingReplyData }> = ({ data, trls }) => {
    const [isTooltipVisible, setTooltipVisibility] = useState(false);
    const activatorRef = useRef<HTMLSpanElement>(null);

    const toggleTooltipVisibility = useCallback(() => {
        setTooltipVisibility((value) => !value);
    }, [setTooltipVisibility]);

    if (!data) {
        return null;
    }

    const hours = Math.floor(data.durationMs / MILLISECONDS_IN_HOUR);
    const days = Math.floor(hours / HOURS_IN_DAY);
    let durationTrl;
    let tagStyle: TagStyle;
    if (hours < 24) {
        tagStyle = 'neutral';
        durationTrl = `${trls[TrlKeys.awaitingReply]} ${hours} ${getConversionType({
            one: trls[TrlKeys.hour.one],
            some: trls[TrlKeys.hour.some],
            many: trls[TrlKeys.hour.many],
            value: hours,
        })}`;
    } else {
        tagStyle = 'warning';
        durationTrl = `${trls[TrlKeys.awaitingReply]} ${days} ${getConversionType({
            one: trls[TrlKeys.day.one],
            some: trls[TrlKeys.day.some],
            many: trls[TrlKeys.day.many],
            value: days,
        })}`;
    }
    if (hours > 71) {
        tagStyle = 'negative';
    }

    return (
        <>
            <span
                data-qa="response_badge_awaiting_reply"
                onClick={toggleTooltipVisibility}
                data-interactive
                ref={activatorRef}
                className={styles.tagClickable}
            >
                <Tag style={tagStyle}>{durationTrl}</Tag>
            </span>
            <Tooltip
                visible={isTooltipVisible}
                activatorRef={activatorRef}
                showClose
                onClose={toggleTooltipVisibility}
                placement="top-center"
            >
                {trls[TrlKeys.dropInfo]}
            </Tooltip>
            <BottomSheet visible={isTooltipVisible} onClose={toggleTooltipVisibility}>
                {trls[TrlKeys.dropInfo]}
            </BottomSheet>
        </>
    );
};

export default translation(AwaitingReply);
